<div
    class="bp-heading"
	[style.background-color]="data.bg_color"
	[style.background-image]="data.hide_bg_image || !data.bg_thumbnail ? '' : ('url(' + data.bg_thumbnail.url + ')')"
>
    <div class="bp-image-dropper-holder">
      <img
        [src]="data.page_image_dropper.thumbnail.url"
        alt=""
      >
    </div>
</div>